import React from 'react';
import './index.scss';

const TipsWrap: React.FC<any> = ({ tip, className, noRect }) => {
    return (
        <div className={`widgets-TipsWrap ${className}`}>
            <span className="tips">{tip}</span>
            {!noRect && <span className="rect"></span>}
        </div>
    );
};

export default TipsWrap;
